// src/Screens/StartupLoader.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import animationData from '../Assets/startup-loader-animation.json'; // <-- your rocket/scan animation

const StartupLoader = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/startup');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="bg-white/80 backdrop-blur-md rounded-[30px] shadow-xl p-6 flex flex-col justify-center items-center min-h-[70vh] w-full max-w-[950px] mx-auto gap-8">
      <div className="w-[300px] md:w-[400px] lg:w-[500px]">
        <Lottie animationData={animationData} loop={true} />
      </div>
      <p className="text-lg md:text-xl font-semibold text-stone-800 font-sora text-center">
        Kumar is scanning India’s fastest-growing startup sectors... 🚀
        <br />
        <span className="text-base text-stone-600 font-medium">
          From AgriTech to Creator Tools — let’s find a space you can thrive in.
        </span>
      </p>
    </div>
  );
};

export default StartupLoader;
